// Direct module cache injection for missing core-js modules
// This adds the missing modules directly to webpack's module cache

// Ensure Array.prototype[Symbol.iterator] is available
if (typeof Symbol !== "undefined" && Symbol.iterator && !Array.prototype[Symbol.iterator]) {
  Array.prototype[Symbol.iterator] = function () {
    let index = 0;
    const array = this;
    return {
      next: function () {
        if (index < array.length) {
          return { value: array[index++], done: false };
        } else {
          return { done: true };
        }
      },
    };
  };
}

// Webpack module cache injection
(function () {
  "use strict";

  // Wait for webpack to load
  let attempts = 0;
  const maxAttempts = 50;

  function injectModules() {
    attempts++;

    if (typeof __webpack_require__ === "undefined" || !__webpack_require__.cache) {
      if (attempts < maxAttempts) {
        setTimeout(injectModules, 10);
      }
      return;
    }

    try {
      // Inject empty stubs for core-js modules webpack can't resolve at build time.
      // This patch runs synchronously before any of these modules are required,
      // so pre-populating the cache prevents the webpackMissingModule throw.
      const emptyModule = { exports: {}, loaded: true, id: "core-js-stub" };

      const stubIds = [
        // es6.array.iterator — required by react-sortly
        "./node_modules/core-js/modules/es6.array.iterator.js",
        "./node_modules/core-js/modules/es6.array.iterator",
        "core-js/modules/es6.array.iterator.js",
        "core-js/modules/es6.array.iterator",
        // es.regexp.test — RegExp.prototype.test is natively supported
        "./node_modules/core-js/modules/es.regexp.test.js",
        "./node_modules/core-js/modules/es.regexp.test",
        "core-js/modules/es.regexp.test.js",
        "core-js/modules/es.regexp.test",
      ];

      stubIds.forEach((id) => {
        if (!__webpack_require__.cache[id]) {
          __webpack_require__.cache[id] = { ...emptyModule, id };
        }
      });
    } catch (error) {
      console.error("[webpack-runtime-patch] Error injecting modules:", error);
    }
  }

  // Start injection process
  injectModules();
})();
